import { LoadingButton } from "@mui/lab";
import { Box, Button, Card, Grid, MenuItem, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import * as XLSX from "xlsx";
import { useApiMutation } from "src/hooks/useApiMutation";

const ImportFromXcel = () => {
	const [openDialogue, setOpenDialogue] = useState(false);
	const [openDialogueImage, setOpenDialogueImage] = useState(false);
	const { register, handleSubmit, setValue, reset } = useForm<any>({});

	const {
		mutate: createStallFromXcel,
		isPending,
		isSuccess,
	} = useApiMutation<FormData, void>({
		method: "POST",
		endPoint: "/api/fair/stall/bulk-stall-import",
		invalidateQueries: ["FairStalls"],
	});

	const onSubmit = (value: any) => {
		const formData = new FormData();
		formData.append("file", value?.file[0]);
		createStallFromXcel(formData);
		console.log(value?.file[0]);
	};

	useEffect(() => {
		if (isSuccess) {
			setOpenDialogue(!openDialogue);
		}
	}, [isSuccess]);
	type FairStallDemo = {
		stall_no: string;
		hall_name: string;
		stall_type: string;
		air_conditioned: string;
		early_bird_price: string;
		super_early_bird_price: string;
		price: string;
	};
	const handleDownloadXLSX = () => {
		const demoData: FairStallDemo[] = [
			{
				stall_no: "C71",
				hall_name: "Carnival",
				stall_type: "STALL",
				air_conditioned: "1",
				early_bird_price: "40000",
				super_early_bird_price: "70000",
				price: "100000",
			},
			{
				stall_no: "H71",
				hall_name: "Harmony",
				stall_type: "CORNER STALL",
				air_conditioned: "0",
				early_bird_price: "40000",
				super_early_bird_price: "70000",
				price: "100000",
			},
			{
				stall_no: "C31",
				hall_name: "Celebrity",
				stall_type: "PAVILION",
				air_conditioned: "1",
				early_bird_price: "40000",
				super_early_bird_price: "70000",
				price: "100000",
			},
			{
				stall_no: "H11",
				hall_name: "Harmony",
				stall_type: "SEMI-PAVILION",
				air_conditioned: "0",
				early_bird_price: "40000",
				super_early_bird_price: "70000",
				price: "100000",
			},
		];

		const worksheet = XLSX.utils.json_to_sheet(demoData);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "Exhibitors");
		XLSX.writeFile(workbook, "demo_fair_stall.xlsx");
	};
	return (
		<>
			<MenuItem onClick={() => setOpenDialogue(true)}>
				Import From xlsx
			</MenuItem>

			<ModalsWrapper
				setShowModal={setOpenDialogue}
				showModal={openDialogue}
				modalData={{ title: "Import From xlsx" }}
			>
				<Grid container justifyContent={"end"}>
					<Grid
						item
						sx={{
							backgroundColor: "rgba(255, 121, 121, 0.08)",
							border: "1px solid rgba(255, 255, 255, 0.2)",
							borderRadius: "8px",
							color: "text.primary",
							padding: "8px 10px",
							fontSize: "0.875rem",
							fontWeight: 500,
							textTransform: "none",
							"&:hover": {
								backgroundColor: "rgba(148, 67, 67, 0.12)",
								borderColor: "rgba(255, 255, 255, 0.3)",
							},
							transition: "all 0.2s ease-in-out",
							cursor: "pointer",
						}}
					>
						<p onClick={() => handleDownloadXLSX()}>See Demo</p>
					</Grid>
				</Grid>
				<Box component="form" onSubmit={handleSubmit(onSubmit)}>
					<Card sx={{ p: "30px" }}>
						<TextField
							fullWidth
							label="Import From xlsx"
							required
							{...register("file")}
							type="file"
							inputProps={{
								accept: ".xls, .xlsx", // Accept only Excel file extensions
							}}
							InputLabelProps={{
								shrink: true,
							}}
						/>
					</Card>
					<Box mt={3}>
						{!isPending ? (
							<Button type="submit" fullWidth variant="contained">
								Submit
							</Button>
						) : (
							<LoadingButton loading fullWidth variant="outlined">
								Loading...
							</LoadingButton>
						)}
					</Box>
				</Box>
			</ModalsWrapper>
			<ModalsWrapper
				setShowModal={setOpenDialogueImage}
				showModal={openDialogueImage}
				modalData={{ title: "Import From xlsx" }}
			>
				<img src="/XCEL.png" width={"100%"} />
			</ModalsWrapper>
		</>
	);
};

export default ImportFromXcel;
